<div (click)="redirect()" class="banner-wrapper {{customClass}}" [ngClass]="{'background-gray': customClass !== 'circle' && lazyLoaded}"  *ngIf="banner.urlBanner">
  <img *ngIf="lazyLoaded && customClass !== 'circle'; else default" class="image v-none lozad banner-braze" [attr.data-src]="banner.urlBanner" [alt]="banner.campaignName">

  <ng-template #default>
    <img *ngIf="lazyLoaded && customClass !== 'circle'" class="image" [src]="banner.urlBanner" [alt]="banner.campaignName">
    <div class="slide-circles" *ngIf="lazyLoaded && customClass === 'circle'">
      <div class="cont-img ad-wrapper">
        <img class="img" [src]="banner.urlBanner" [alt]="banner.label" *ngIf="!lazyLoadImg">
      </div>
      <p class="text-categorie">{{banner.label}}</p>
    </div>
  </ng-template>
</div>
